const ACTION_TYPES = {
    ADD_EXISTING_TEST_CASES: 'ADD_EXISTING_TEST_CASES',
    ADD_NEW_TEST_CASES: 'ADD_NEW_TEST_CASES',
};

export default ACTION_TYPES;
